import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import TestSearchProvider from './contexts/test-search.context';
import LabTestContent from './components/labtest-content.component';
import './labtest.page.css';

const Labtest = () => {
  return (
    <Container className='doc-cat-content labtest-page'>
        <Box>
            <Typography className='ext-large-brown-txt'>
                Lab Test
            </Typography>
        </Box>
        <TestSearchProvider>
            <LabTestContent />
        </TestSearchProvider>
    </Container>
  );
};

export default Labtest;